import React, { Component } from 'react'

import Button from 'components/UI/Button/Button'
import Icon from 'components/UI/Icon/Icon'
import { Wrapper, StyledButton } from './TeacherInfoRow.styles'
import { StyledFormInput } from '../../../../DashboardSettings.styles'
import { colors } from 'modules/dashboard/Home/Dashboard.global.styles'

export default class TeacherInfoRow extends Component {
  constructor (props) {
    super(props)

    this.onInputChange = this.onInputChange.bind(this)
  }

  onInputChange (e) {
    this.props.setTeacherState({
      _id: this.props.info._id,
      field: e.target.name,
      value: e.target.value
    })
  }

  shouldShowDeleteButton (info) {
    if (!this.props.isEditMode) return false
    if (info.stagedForDeletion) return false
    if (this.props.isLoggedInUser) return false
    return true
  }

  render () {
    const { screenWidth, info, isEditMode, isFirstRow, onRemoveTeacher } = this.props

    const commonProps = {
      placeholderColor: isEditMode && info.isNew ? colors.grey : colors.orange,
      backgroundColor: isEditMode && info.isNew ? null : colors.paleBlue,
      inputColor: isEditMode && info.isNew ? null : colors.darkPurple,
      fieldNameColor: colors.pink,
      noBorder: !(isEditMode && info.isNew),
      focusColor: colors.orange,
      backgroundFocusColor: colors.lightOrange,
      element: 'button',
      narrow: true,
      textSize: '15px',
      fieldNameSize: '18px',
      inputOpacity: info.stagedForDeletion ? '0.5' : '1',
      disabled: !(isEditMode && info.isNew),
      autoComplete: 'off',
      width: screenWidth <= 950 ? '180px' : '220px'
    }

    return (
      <Wrapper>
        {!info.isNew &&
          <StyledFormInput
            {...commonProps}
            value={info.name}
            onChange={this.onInputChange}
            name='name'
            fieldName={isFirstRow ? 'Name' : null}
            placeholder='Teacher name'
          />
        }
        <StyledFormInput
          {...commonProps}
          value={info.email}
          onChange={this.onInputChange}
          name='email'
          fieldName={isFirstRow ? 'Email' : null}
          placeholder='Teacher email'
          alignedRight={info.isNew}
          required
          validations='isEmail'
          validationError='Email not valid'
        />
        {this.shouldShowDeleteButton(info) &&
          <div onClick={() => onRemoveTeacher(info._id)}>
            <StyledButton
              element='button'
              type='button'
              size='regular'
              round
              bgColor={colors.red}
              isFirstRow={isFirstRow}
            >
              <Icon
                name='trash'
                color='white'
                size='regular'
              />
            </StyledButton>
          </div>
        }
      </Wrapper>
    )
  }
}
